import { ApiResponse, PartnerAccountTransferRequest, SupportedTransferTypes } from 'vopay';
import { api } from '@/services/api.config';

export type PartnerAccountTransferParams = Omit<PartnerAccountTransferRequest, 'TransferTypeID'> & {
  TransferTypeID: SupportedTransferTypes;
};

// One endpoint per transfer type; the request shape is the same for all four.
const TRANSFER_BY_TYPE: Record<
  SupportedTransferTypes,
  (params: PartnerAccountTransferRequest) => Promise<ApiResponse>
> = {
  Transfer: (params) => api.postPartnerAccountTransfer(params),
  FundAndTransfer: (params) => api.postPartnerAccountFundAndTransfer(params),
  TransferAndWithdraw: (params) => api.postPartnerAccountTransferAndWithdraw(params),
  FundTransferAndWithdraw: (params) => api.postPartnerAccountFundTransferAndWithdraw(params),
};

/** Moves funds between two of the partner's accounts, optionally funding and/or withdrawing around the move. */
export default function usePartnerAccountTransfer() {
  async function transferPartnerAccountFunds(params: PartnerAccountTransferParams) {
    try {
      // The form's serialization is untyped, so the type is checked here rather than trusted.
      const transfer = Object.hasOwn(TRANSFER_BY_TYPE, params.TransferTypeID)
        ? TRANSFER_BY_TYPE[params.TransferTypeID]
        : undefined;

      if (!transfer) throw new Error(`Unsupported transfer type: ${params.TransferTypeID}`);

      const res = await transfer(params);

      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  return { transferPartnerAccountFunds };
}
